import React from "react";
import { Steps } from "antd";
import styled from "styled-components";
import { registerScreens, stepStatus } from "../../util/util";
import { withLocalizeStrings } from "../../languages/Localize";
import { useRegisterStateValue } from "../RegisterContext";
import { Flex } from "reflexbox/src";

const { Step } = Steps;

const StyledLayout = styled(Flex)`
    position: fixed;
    z-index: 5;
    height: 80px;
    flex-direction: row;
    background: ${({ theme }) => theme.colors.white};
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.35);
    align-items: center;
`;
const StyledHeaderLabel = styled(Flex)`
    color: ${({ theme }) => theme.colors.primary};
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: ${({ theme }) => theme.space[2]}px;
`;

const StyledSteps = styled(Steps)`
    && {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        padding: ${({ theme }) => theme.space[2]}px;
        padding-right: ${({ theme }) => theme.space[4]}px;
        width: unset;
    }
    && .ant-steps-item-content,
    && .ant-steps-item::before {
        display: none;
    }

    && .ant-steps-item::after {
        content: ".";
        margin: unset;
        top: 12px;
        left: 108%;
        display: block;
        width: 5px;
        height: 5px;
        ${({ theme }) => theme.mediaQueries.small} {
            width: 7px;
            height: 7px;
            top: 12px;
            left: 104%;
        }
        ${({ theme }) => theme.mediaQueries.medium} {
            width: 7px;
            height: 7px;
            top: 13px;
        }
        border-color: ${({ theme }) => theme.colors.primary};
        text-align: center;
        transform: rotate(45deg);
    }

    && .ant-steps-item:last-child::after {
        display: none;
    }

    && .ant-steps-item {
        flex: unset;
        margin: 12px;
        ${({ theme }) => theme.mediaQueries.small} {
            margin: 14px;
        }
    }
    && .ant-steps-item-icon {
        margin: unset;
        text-align: center;
        width: 26px;
        height: 26px;
        font-size: 14px;
        line-height: 25px;
        ${({ theme }) => theme.mediaQueries.small} {
            width: 30px;
            height: 30px;
            font-size: 16px;
            line-height: 29px;
        }
    }
    && .ant-steps-item-container {
        display: unset;
        margin: unset;
    }
    && .ant-steps-item-process .ant-steps-item-icon {
        background: ${({ theme }) => theme.colors.primary};
        border-color: ${({ theme }) => theme.colors.primary};
    }
    && .ant-steps-item-finish .ant-steps-item-icon {
        background: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.primary};
        border-color: ${({ theme }) => theme.colors.primary};
    }
    && .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
        color: ${({ theme }) => theme.colors.primary};
    }
`;

const steps = [
    { id: registerScreens.PURCHASER },
    { id: registerScreens.ATTENDERS },
    { id: registerScreens.REGISTRATION_FEE },
    { id: registerScreens.VERIFICATION }
];

const RegisterHeader = ({ strings }) => {
    const { currentScreen, changeScreen, availableSteps } = useRegisterStateValue();
    const handleStepStatus = (registerScreen, currentScreen) => {
        if (registerScreen === currentScreen) return stepStatus.PROCESS;
        else if (registerScreen < currentScreen) return stepStatus.FINISH;
        return stepStatus.WAITING;
    };
    const handleStepChange = current => {
        changeScreen(current);
    };

    return (
        <>
            <StyledLayout>
                <StyledHeaderLabel fontWeight="light" fontSize={[2, 3]} padding={3}>
                    {strings.register.common.HEADER}
                </StyledHeaderLabel>
                <StyledSteps type="navigation" current={currentScreen} onChange={handleStepChange} direction="horizontal" size="small">
                    {steps.map(step => (
                        <Step key={`step#${step.id}`} status={handleStepStatus(step.id, currentScreen)} disabled={!availableSteps[step.id]} />
                    ))}
                </StyledSteps>
            </StyledLayout>
        </>
    );
};
export default withLocalizeStrings(RegisterHeader);
